import { render, staticRenderFns } from "./SopBlockDetailHeader.vue?vue&type=template&id=d41f2e1a&scoped=true&"
import script from "./SopBlockDetailHeader.vue?vue&type=script&lang=ts&"
export * from "./SopBlockDetailHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d41f2e1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
